import React from "react";
import { formatInr } from "../lib/accountsSettlement";

/**
 * SUPPLIER_DIRECT_YARD: commission is capitalized into inventory landed cost.
 */
export default function SupplierLandedCostCard({ preview, allocation }) {
  const mode = preview?.settlement_mode || allocation?.settlement_mode || allocation?.deductions?.settlement_mode;
  if (mode !== "SUPPLIER_DIRECT_YARD") return null;

  const baseRate = Number(
    preview?.base_paddy_rate
    ?? allocation?.base_rate
    ?? allocation?.effective_rate
    ?? 0,
  );
  const commissionRate = Number(
    preview?.commission_rate
    ?? allocation?.commission_rate
    ?? allocation?.deductions?.commission_rate
    ?? 0,
  );
  const landedRate = Number(
    preview?.effective_landed_rate
    ?? allocation?.effective_landed_rate
    ?? allocation?.deductions?.effective_landed_rate
    ?? (baseRate + commissionRate),
  );
  const commissionAmount = Number(
    preview?.commission_amount
    ?? allocation?.commission_amount
    ?? allocation?.deductions?.commission_amount
    ?? 0,
  );
  const totalMaterial = Number(
    preview?.total_material_value
    ?? allocation?.total_material_value
    ?? allocation?.deductions?.total_material_value
    ?? 0,
  );

  return (
    <div
      className="rounded-md border border-emerald-200 bg-emerald-50/70 p-4 space-y-2"
      data-testid="supplier-landed-cost-card"
    >
      <div>
        <p className="text-xs font-medium text-slate-900">Landed inventory cost</p>
        <p className="text-[10px] text-muted-foreground mt-0.5">
          Supplier commission is capitalized into the material voucher (not a separate expense voucher).
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
        <div>
          <p className="text-[10px] uppercase text-muted-foreground">Base paddy price</p>
          <p className="tabular font-medium">{formatInr(baseRate)} / Qtl</p>
        </div>
        <div>
          <p className="text-[10px] uppercase text-muted-foreground">Supplier commission</p>
          <p className="tabular font-medium text-primary">+ {formatInr(commissionRate)} / Qtl</p>
          {commissionAmount > 0 && (
            <p className="text-[10px] text-muted-foreground tabular">{formatInr(commissionAmount)} total</p>
          )}
        </div>
        <div>
          <p className="text-[10px] uppercase text-muted-foreground">Final landed cost</p>
          <p className="tabular font-semibold text-slate-900">{formatInr(landedRate)} / Qtl</p>
          {totalMaterial > 0 && (
            <p className="text-[10px] text-muted-foreground tabular">Payable {formatInr(totalMaterial)}</p>
          )}
        </div>
      </div>
    </div>
  );
}
